module.exports = __webpack_public_path__ + "img/jesus-spectacle-musical.ef605cae.jpg";